import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Lightning, Users, Storefront } from '@phosphor-icons/react';
import api from '@/lib/api';

export default function RoleSelection() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  var googleData = location.state?.googleData;
  var pendingToken = location.state?.pending_token;
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState('affiliate');

  if (!googleData) {
    navigate('/login');
    return null;
  }

  var handleSubmit = async function () {
    setLoading(true);
    try {
      var resp = await api.post('/auth/google/session', { pending_token: pendingToken, role: selected });
      var data = resp.data;
      if (data.token) localStorage.setItem('dw_token', data.token);
      if (typeof setUser === 'function') setUser(data);
      var dest = data.role === 'admin' ? '/admin' : data.role === 'advertiser' ? '/advertiser' : '/affiliate';
      navigate(dest);
    } catch (err) {
      console.error(err);
      navigate('/login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Lightning size={28} weight="duotone" className="text-white" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-white">Welcome, {googleData.name}!</h1>
          <p className="text-sm text-zinc-400 mt-1">Choose your account type to get started</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 space-y-4">
          <button
            data-testid="select-affiliate"
            onClick={function () { setSelected('affiliate'); }}
            className={'w-full p-4 rounded-xl border transition-all flex items-center gap-4 ' +
              (selected === 'affiliate' ? 'bg-blue-600/15 border-blue-500/30 text-blue-400' : 'bg-zinc-950 border-zinc-800 text-zinc-400 hover:border-zinc-700')}
          >
            <Users size={28} weight="duotone" />
            <div className="text-left">
              <p className="font-medium text-sm">Affiliate</p>
              <p className="text-xs text-zinc-500">Promote offers, earn commissions, build your network</p>
            </div>
          </button>

          <button
            data-testid="select-advertiser"
            onClick={function () { setSelected('advertiser'); }}
            className={'w-full p-4 rounded-xl border transition-all flex items-center gap-4 ' +
              (selected === 'advertiser' ? 'bg-blue-600/15 border-blue-500/30 text-blue-400' : 'bg-zinc-950 border-zinc-800 text-zinc-400 hover:border-zinc-700')}
          >
            <Storefront size={28} weight="duotone" />
            <div className="text-left">
              <p className="font-medium text-sm">Advertiser</p>
              <p className="text-xs text-zinc-500">List offers, drive traffic, track conversions</p>
            </div>
          </button>

          <Button
            data-testid="confirm-role"
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium mt-4"
          >
            {loading ? 'Setting up...' : 'Continue as ' + selected.charAt(0).toUpperCase() + selected.slice(1)}
          </Button>
        </div>
      </div>
    </div>
  );
}
